import React from "react";
import clsx from "clsx";

import { ReactComponent as CancelIcon } from "static/images/cancel.svg";
import styles from "./closeButton.module.scss";

const defaultIcon = <CancelIcon className={styles.closeIcon} />;

const CloseButton = ({
	icon = defaultIcon,
	className = "",
	onClick,
	...props
}) => {
	return (
		<button
			type="button"
			className={clsx(className, styles.closeBtn)}
			onClick={onClick}
			{...props}
		>
			{icon}
		</button>
	);
};

export default CloseButton;
